import React from 'react';
import { Panel, BarRow } from './parts';

const pct = (n, total) => (total ? Math.round((n / total) * 1000) / 10 : 0);
const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, '-');

const List = ({ title, rows, total, prefix }) => (
  <div>
    <div className="text-xs font-semibold text-slate-500 mb-2">{title}</div>
    {rows.length ? (
      <div className="space-y-3">
        {rows.map((r) => <BarRow key={r.label} label={r.label} count={r.count} pct={pct(r.count, total)} testId={`${prefix}-${slug(r.label)}`} />)}
      </div>
    ) : <p className="text-sm text-slate-400">No signups in this period.</p>}
  </div>
);

export const SignupSources = ({ s }) => (
  <Panel title={`New accounts · ${s.total}`} testId="growth-signups">
    <div className="space-y-6">
      <List title="How they signed up" rows={s.by_method} total={s.total} prefix="growth-method" />
      <List title="Where they came from" rows={s.by_source.slice(0, 10)} total={s.total} prefix="growth-source" />
    </div>
    <p className="text-xs text-slate-400 mt-4">From the first link a visitor arrived on (ad, search, social, or a link with utm_source). "Not tracked" means they joined before tracking started.</p>
  </Panel>
);
